/* eslint-disable */
import Totals from './Totals'

function RoutesMap(map, styles, zoom) {
  var self = this,
    mapObj = new google.maps.Map(document.getElementById(map), {
      mapTypeControl: false,
      center: { lat: 50.86, lng: 4.3517 },
      disableDefaultUI: true,
      zoom: zoom || 13,
      styles: styles && styles.simple || null
    });

  this.matrixService = new google.maps.DistanceMatrixService;
  this.directionsService = new google.maps.DirectionsService;
  this.directionsDisplay = new google.maps.DirectionsRenderer();
  this.directionsDisplay.setMap(mapObj);

  this.update = function (data) {
    self.directionsService.route({
      origin: data.orginInput,
      destination: data.destInput,
      waypoints: data.waypts,
      optimizeWaypoints: data.optimizeWaypoints,
      travelMode: 'DRIVING'
    }, function (response, status) {
      if (status === 'OK') {
        console.log(response)
        self.directionsDisplay.setDirections(response);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
  }

  this.setDirections = function (response, status) {
    if (status === 'OK') {
      console.log(response)
      self.directionsDisplay.setDirections(response);
    } else {
      window.alert('Directions request failed due to ' + status);
    }
  }

  this.reset = function () {
    self.directionsDisplay.setDirections({routes: []});
  }

	/*
	start, dist1, dist2, dist3
	0,1,2,3

	allee
	1: 0-1
	5: 1-2
	6: 2-0

	retour
	2: 0-2
	7: 2-1
	3: 1-0

					        Antwerpen			      Mechelen			      Brussels
	Antwerpen		row[0].elements[0] 	row[0].elements[1] 	row[0].elements[2]
					           1

	Mechelen		row[1].elements[0] 	row[1].elements[1] 	row[1].elements[2]
										                      1

	Brussels		row[2].elements[0] 	row[2].elements[1] 	row[2].elements[2]
															                                1

					distance.text
					duration.text

	*/

  this.showRoute = function (inputs) {

    var data = inputs.reduce(function (filtered, input) {
      if (input.value) {
        filtered.push(input.value);
      }
      return filtered;
    }, []);

    self.matrixService.getDistanceMatrix({
      origins: data,
      destinations: data,
      travelMode: 'DRIVING',
      unitSystem: google.maps.UnitSystem.METRIC,
      avoidHighways: false,
      avoidTolls: false
    }, function (response, status) {
      if (response.rows.length > 2) {

        self.renderData(response);
      } else {
        self.clearData();
      }
    });
  }

  this.clearData = function (data) {
    this.outputDiv = document.getElementById('output');
    if (this.outputDiv.firstChild) {
      this.outputDiv.removeChild(this.outputDiv.firstChild);
    }
  }

  this.renderData = function (output) {

    // var output = this.getOuput(data);
    var newdiv = document.createElement('div'),
      arr = output.to, html;
      html = 'TRAJECT : ';
      html += '<span class"details-distance">' + arr[1].distance.text + ' - ' + arr[1].duration.text + '</span>';
    html += '<div class="totals">';
    html += '<div>' + '<span>Aller ou retour (1 traject) : </span>' + output.totals.to.distance.round(1) + ' km - ' + this.toTime(output.totals.to.duration) + ' - ' + output.totals.to.price + ' eur</div>';
    html += '<div>' + '<span>Aller et retour : </span>' + output.totals.total.distance.round(1) + ' km - ' + this.toTime(output.totals.total.duration) + ' - ' + output.totals.total.price + ' eur</div>';
    html += '</div>';


    html += '<ul class"details"> ';
    arr.forEach(function (r) {
      html += '<li class="trip">' + r.trip.origin + ' --> ' + r.trip.destination + '</li>';
      html += '<li>' + r.distance.text + ' - ' + r.duration.text + ' - ' + r.price.text + '</li>';
    })
    html += '</ul>';

    html += '</ul>';
/*
    arr = output.back;
    html += '<ul class"details"> Retour:';
    arr.forEach(function (r) {
      html += '<li class="trip">' + r.trip.origin + ' --> ' + r.trip.destination + '</li>';
      html += '<li>' + r.distance.text + ' - ' + r.duration.text + ' - ' + r.price.text + '</li>';
    })
    html += '</ul>';
*/
    newdiv.innerHTML = html;

    this.outputDiv = document.getElementById('output');
    if (this.outputDiv.firstChild) {
      this.outputDiv.removeChild(this.outputDiv.firstChild);
    }
    this.outputDiv.appendChild(newdiv);
  }

  this.calcOutput = function (xarr, data) {
    var output = {}, totals = new Totals(), what = Object.keys(xarr), w, i, x, y, elements, price, arr;

    for (w = 0; w < what.length; w++) {
      arr = xarr[what[w]];
      output[what[w]] = [];
      for (i = 0; i < arr.length; i++) {
        x = arr[i][0];
        y = arr[i][1];
        elements = data.rows[x].elements;
        price = Math.ceil((elements[y].distance.value / 1000) * 0.3595);

        totals[what[w]].distance += elements[y].distance.value / 1000;
        totals[what[w]].duration += elements[y].duration.value;
        totals[what[w]].price += price;
        output[what[w]].push({
          trip: {
            origin: data.originAddresses[x],
            destination: data.originAddresses[y]
          },
          distance: elements[y].distance,
          duration: elements[y].duration,
          price: price + ' eur'
        });
      }
      totals.total.distance += totals[what[w]].distance;
      totals.total.duration += totals[what[w]].duration;
      totals.total.price += totals[what[w]].price;
    }
    output.totals = totals;
    return output;
  }

  this.getOuput = function (data) {
    var indexes = this.getIndexes(data.rows.length);
    return this.calcOutput(indexes, data);
  }

  this.getIndexes = function (len) {
    var simple, to, back;
    simple = this.getSimple(len);
    to = this.sort(len);
    back = this.reverse(to);
    return {
      simple: simple,
      to: to,
      back: back
    };
  }

  this.toTime = function (sec) {
    var time;
    if (sec > 3600) {
      time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
    } else {
      time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
    }
    return time;
  }

  this.sort = function (len) {
    var arr = [], i, y;
    for (i = 0; i < len; i++) {
      y = i + 1;
      y = (y < len) ? y : 0;
      arr[i] = [i, y];
    }
    return arr;
  }

  this.getSimple = function (len) {
    var arr = [], i, y;
    for (i = 0; i < len-1; i++) {
      y = i + 1;
      arr[i] = [i, y];
    }
    return arr;
  }

  this.reverse = function (arr) {
    var rev = JSON.parse(JSON.stringify(arr));
    rev.reverse();
    rev.map(function (a) {
      a.reverse();
    });
    return rev;
  }

  Number.prototype.round = function (p) {
    p = p || 10;
    return parseFloat(this.toFixed(p));
  };

}

export default RoutesMap
